<template>
  <main>
    <van-nav-bar
        title="单位信息收集"
        left-text="返回"
        left-arrow
        @click-left="backLogin"/>

      <van-field
        readonly
        clickable
        name="picker"
        :value="form.fplxmc"
        label="开票类型"  is-link
        placeholder="点击选择开票类型"
        @click="showPicker = true"
      />

    <van-form @submit="onSubmit">
        <van-field
            v-model.trim="form.unitName"
             @blur="nameSyn"
            maxlength="40"
            show-action
              clearable
            required
            label="单位名称"
            :rules="[{ required: true }]"
            placeholder="请输入单位名称">
            <template #button>
                <van-icon name="search" @click="searchCustomer()" />
            </template>
        </van-field>

       <van-field
      v-model.trim="form.corpName"
      name="corpName"
      required
        clearable
      maxlength="40"
      label="购方名称"
      placeholder="请填写购方名称"
      :rules="[{ required: true }]"
    />
<van-popup v-model="showPicker" position="bottom">
  <van-picker
    show-toolbar
    :columns="columns"
    @confirm="onConfirm"
    @cancel="showPicker = false"
  />
</van-popup>
      <van-field
      v-model.trim="form.corpNsrsbh"
      name="corpNsrsbh"
      clearable
      maxlength="20"
      label="购方税号"
      placeholder="请填写购方税号"
     
    />

       <van-field
      
      v-model.trim="form.corpDzdh"
      name="corpDzdh"
        clearable
      maxlength="100"
      label="地址电话"
      placeholder="地址电话"
    />

      <van-field
      v-model.trim="form.corpYhzh"
      name="开户行及账号"
        clearable
        maxlength="50"
      label="开户行及账号"
      placeholder="开户行及账号"
    />

    <van-field
      v-model.trim="form.mail"
      name="推送邮箱"
      clearable
      label="推送邮箱"
      maxlength="100"
      placeholder="请填写推送邮箱" />

       <van-field
      v-model.trim="form.phone"
      name="phone"
        clearable
      label="联系电话"
      maxlength="12"
      placeholder="联系电话"
    />
        <van-field
        readonly
        clickable
        name="year"
        :value="form.year"
        label="缴费年度"
        is-link
        placeholder="点击选择缴费年度"
        @click="showPickerYear = true"
        />
        <van-popup v-model="showPickerYear" position="bottom">
        <van-picker
            show-toolbar
            :columns="columnsYear"
            @confirm="onConfirmYear"
            @cancel="showPickerYear = false"
        />
        </van-popup>

       <van-field
      v-model.trim="form.numberOfUnits"
       type="digit"
      name="numberOfUnits"
      @input="setTotalPriceByUnit"
      label="单位人数"
      maxlength="10"
       required
      placeholder="请填写单位人数" 
       :rules="[{ required: true }]"
    />
    <van-field
      v-model.trim="form.months"
       type="digit"
      name="months"
      @input="setTotalPriceBymonths"
      label="月份数"
      maxlength="2"
       required
      placeholder="请填写月份人数" 
       :rules="[{ required: true }]"
    />

     <van-field
      v-model="form.chargingStandardStr"
       readonly
      name="chargingStandardStr"
      label="收费标准"
       required
      placeholder="收费标准" 
       :rules="[{ required: true, message: '请填写收费标准' }]"
    />

      <van-field
      v-model="form.totalPrice"
       readonly
      name="totalPrice"
      label="总金额"
      placeholder="总金额" 
    >
<div slot="label" class="flex">
                    <span  style="color:red">总金额</span>
                </div>
          </van-field>
    <van-field
      v-model="form.remarks"
        clearable
      label="开票备注"
      placeholder="开票备注" />
    

  <div style="margin: 16px;">
    <van-button round block type="primary" native-type="submit">
      提交
    </van-button>
  </div>
</van-form>


<div class="selector">  <!-- 选择客户-->
    <van-popup v-model="showPickerCustomer" position="bottom" >
        <van-search  v-model="searchText" placeholder="搜索" @input="onSearch"> </van-search>
         <van-picker show-toolbar :columns="showOptions" @confirm="onConfirmCustomer"  value-key="enterpriseName"
          @cancel="showPickerCustomer=false" @change="onChange">
           <template #option="option">
              <div style="display: flex; flex-direction: column; align-items: center; text-align:center">
                <div>{{ option.unitName }}/{{ option.khNsrsbh }}</div>
              </div>
            </template>
         </van-picker>
    </van-popup> 
  </div>
  </main>
</template>
<script>
import Vue from "vue";
import {
   Col, Row,
  ActionSheet,
  Button,
  Collapse,
  CollapseItem,
  Field,
  Form,
  Cell, 
  CellGroup,
  Icon,
  NavBar,
  Radio,
  RadioGroup,
  Sticky,
  Tab,
  Tabs,
  Toast,
  Search,
  Picker,
  Dialog 
} from "vant";
Vue.use(Col);
Vue.use(Row);
Vue.use(Tabs);
Vue.use(Tab);
Vue.use(Icon);
Vue.use(Button);
Vue.use(Field);
Vue.use(Form);
Vue.use(NavBar);
Vue.use(ActionSheet);
Vue.use(Collapse);
Vue.use(CollapseItem);
Vue.use(Radio );
Vue.use(RadioGroup);
Vue.use(Sticky);
Vue.use(Cell);
Vue.use(CellGroup);
Vue.use(Search);
Vue.use(Picker);
Vue.use(Dialog);
export default {
    
data() {
    return {
      showPickerCustomer:false,
      showPicker:false,
      showPickerYear:false,
      viewZp:false,
      searchText:'',
      showOptions:[],
      form:{ 
        totalPrice:'',
        customerId:'',
        unitName: '', //单位名称
         corpName:'',
         corpNsrsbh:'',
         fplxmc:'数电普票',
         months:'1',
         fplx:'82',
         year:'2025',
         corpDzdh:'',
         corpYhzh:'',
         contactNumber:'',  //联系电话
         phone:'',
         mail:'',
         numberOfUnits:'',
         chargingStandard:"3",
         chargingStandardStr:"3元/人/月",
         remarks:''

      },
      columns: ['数电普票', '数电专票'],
      columnsYear:['2025','2026','2027','2028','2029','2030','2031',
      '2032','2033','2034','2035','2036','2037'
      ]
    }
},
 created(){

    
     this.form.year= new Date().getFullYear()
     console.log( this.form.year);

 },
 methods: {

   nameSyn(){   //关联单位
       this.form.corpName=this.form.unitName;

    }, 

    setTotalPriceBymonths(oldValue){
     
     let  units=this.form.numberOfUnits;
     if(units==''){
       this.form.numberOfUnits=1;
       units=1;
     }
     this.form.totalPrice=units*oldValue*1*3;

  },

    /**
     * 单位
     */
    setTotalPriceByUnit(oldValue){
     
      let  months=this.form.months;
      if(months==''){
        this.form.months=1;
        months=1;
      }
      this.form.totalPrice=months*oldValue*1*3;

   },

   backLogin(){   //返回
      this.$router.push({path: '/login'});
   },
    onSearch(){  //内置的查询事件

     if (this.searchText === '' || this.searchText === null) {
        this.showOptions = this.options;
      } else {
             this.showOptions = this.options.filter((e) => e.unitName.toLowerCase().indexOf(
             this.searchText.toLowerCase()) != -1||e.khNsrsbh.toLowerCase().indexOf(
             this.searchText.toLowerCase()) != -1)
      }

    },

   close(){   //关闭弹窗
       this.showPicker=false;
   },
    onChange(picker, value, index){   //选择客户改变事件
         this.form.numberOfUnits=value.shopArea;
       this.form.customerId=value.id;
        this.form.corpName= value.khName;
        this.form.unitName=value.unitName;
        this.form.customerId=value.id;
        this.form.corpNsrsbh=value.khNsrsbh;
        this.form.corpDzdh=value.khDzdh;
        this.form.corpYhzh=value.khYhzh;
        this.form.phone=value.phone;
        this.form.mail=value.mail;
        this.form.money=value.money;
        this.form.remarks=value.remarks;
        this.form.fplx=value.khFplx;
        console.log(this.form.fplx); 
        if(this.form.fplx=='81'){
          this.form.fplxmc='数电专票';
        }else{
          this.form.fplxmc='数电普票';

        }

    },
   onConfirmCustomer(value, index){   //客户确认事件
         if(value!=undefined){
        this.form.totalPrice=value.shopArea*1*36;   
        this.form.numberOfUnits=value.shopArea;
        this.form.customerId=value.id;
        this.form.corpName= value.khName;
        this.form.unitName=value.unitName;
        this.form.customerId=value.id;
        this.form.corpNsrsbh=value.khNsrsbh;
        this.form.corpDzdh=value.khDzdh;
        this.form.corpYhzh=value.khYhzh;
        this.form.phone=value.phone;
        this.form.mail=value.mail;
        this.form.money=value.money;
        this.form.remarks=value.remarks;
        this.form.fplx=value.khFplx;
        console.log(this.form.fplx); 
        if(this.form.fplx=='81'){
          this.form.fplxmc='数电专票';
        }else{
          this.form.fplxmc='数电普票';
        }
      //   if(this.form.fplx=='026'){
      //        this.form.fplxmc='电票';
      //          this.viewZp=false;
      //  }else if(this.form.fplx=='004'){
      //         this.form.fplxmc='专票';
      //          this.viewZp=true;
      //  }else{
      //       this.form.fplxmc='普票';  //普票
      //        this.viewZp=false;
      //  }
       this.showPickerCustomer=false;
      }
 
   },
    searchCustomer(){   //搜索事件打开弹出层


   if(this.form.unitName==''){

       Toast("请输入名称后再搜索");

     return;
   }
    const url = "/index/customerList";
    this.$axios
      .get(url, {whetherUnits:"1",unitName:this.form.unitName})
      .then((data) => {
        this.showOptions = data.data;
        this.options=data.data;
         this.showPickerCustomer=true;
      })
      .catch((error) => {
        //请求失败返回的数
        Toast({
          message: error.message,
          position: "middle",
          duration: 2000,
        });
      })

    },

    
      addZero(s) {
      return s<10?('0'+s):s;
      },

     onConfirmYear(value){
    
        this.form.year = value;
        this.showPickerYear = false;

     },
     onConfirm(value){
        this.form.fplxmc = value;
        if(this.form.fplxmc=='数电专票'){
          this.form.fplx='81'
          this.viewZp=true;
        
        }else if(this.form.fplxmc=='数电普票'){
            this.form.fplx='82'
            this.viewZp=false;
        }else{
            this.form.fplx='007'
            this.viewZp=false;
        }
        this.showPicker = false;
     },

    SubmitOrders(){
       this.form.orderId=this.randomNumber();
      console.log(this.form)
        this.$axios
        .post("/units/addOrders",this.form).then((data) => {
          if(data.code==200){
        Dialog.confirm({
          title: '提交成功',
          message: '是否返回',
        })
          .then(() => {
              this.$router.push({path: 'loginjudge'})
          })
          .catch(() => {
            // on cancel
          });

          
          }else{
             Toast(data.message); 
          }
      });


    },


   checkOrders(){
     
        let  that=this;
        this.$axios
        .post("/units/checkOrders",{
           corpNsrsbh:this.form.corpNsrsbh,
           year:this.form.year

        }).then((data) => {
          if(data.code==200){
          // Toast(data.message);

             that.SubmitOrders(); 

          
          }else{
                Dialog.confirm({
            title: '确认提交',
            message: '今年已经缴过费了，是否再次提交',
          })
            .then(() => {
              // on confirm

                that.SubmitOrders();  //提交 
            })
            .catch(() => {
              // on cancel
            });
          }
      });


    },

   checkTax(obj) {
      if (/^[A-Z0-9]{15}$|^[A-Z0-9]{17}$|^[A-Z0-9]{18}$|^[A-Z0-9]{20}$/.test(obj)) {
        return true;
      }else{
        return false;
      }
    },

    onSubmit(){
     //先判断发票类型
     if(this.form.fplx=='81'){
        if(this.form.corpDzdh==''){
            Toast("选择专票地址电话不能为空");
            return ;
         }
         if(this.form.corpYhzh==''){
            Toast("选择专票地址银行账号不能为空");
            return ;
         }
      

     }
     if(this.form.numberOfUnits<0){
        Toast("单位人数不能为空");
        return ;
     }

     if(this.form.mail.length>0){
      var reg_email = /^\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/;
       if(!reg_email.test(this.form.mail)){
            Toast('邮箱格式异常')
                return ''
        }
     }
     if(this.form.corpNsrsbh.length>0){
      if(this.checkTax(this.form.corpNsrsbh)==false){
            Toast('税号检验异常')
            return ''
        }
     }
     this.checkOrders();
    
    }
}

}
</script>